import React, { useEffect,useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function AdminHomePage() {
 
  
   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();


  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const token = localStorage.getItem("token");
        const Email = localStorage.getItem("email");
        const Role = localStorage.getItem("role");

        // If anything missing → logout
        if (!token || !Email || !Role) {
          localStorage.clear();
          navigate("/user/sign_in");
          return;
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          {
            Email,
            Role,
            Token: token,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // If backend says not valid
        if (!response.data.success) {
          localStorage.clear();
          navigate("/user/sign_in");
        }

      } catch (error) {
        // console.error("User validation failed:", error);
        localStorage.clear();
        navigate("/user/sign_in");
      }
    };

    checkUser();
  }, [navigate]);

  

  return (
    <div>
      <h2 className="text-2xl font-bold">Admin Home Page</h2>
    </div>
  );
}

export default AdminHomePage;